/* eslint-disable consistent-return */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/**
 * Puma
 * @category    ScandiPWA
 * @author      Beshoy Samuel <info@scandiweb.com>
 * @copyright   Copyright (c) 2023 Scandiweb, Ltd (https://scandiweb.com)
 */

import { connect } from 'react-redux';

import { WISHLIST_ERROR } from 'Component/Notification/Notification.config';
import {
    mapDispatchToProps,
    mapStateToProps,
    ProductWishlistButtonContainer as SourceProductWishlistButtonContainer
} from 'Component/ProductWishlistButton/ProductWishlistButton.container';
import { isSignedIn } from 'Util/Auth';

import ProductCardWishlistComponent from './ProductCardWishlist.component';

/** @namespace Scandipwa/Component/ProductCardWishlist/Container */
export class ProductCardWishlistContainer extends SourceProductWishlistButtonContainer {
    isInWishlist() {
        const { magentoProduct } = this.props;

        if (!magentoProduct) {
            return false;
        }

        const { sku: productSku } = magentoProduct;

        if (!productSku) {
            return false;
        }

        return !!this.getWishlistItem(productSku);
    }

    getWishlistItem() {
        const {
            productsInWishlist,
            magentoProduct: { variants = [] },
            color
        } = this.props;

        if (!productsInWishlist || variants.length === 0) {
            return null;
        }

        if (color) {
            const variant = variants.find(
                ({ color: vcolor }) => +vcolor === +color
            );

            if (variant) {
                const { style_number } = variant;

                return Object.values(productsInWishlist).find(
                    ({ sku: wishlistSku }) => style_number === wishlistSku
                );
            }
        }

        return false;
    }

    async toggleProductInWishlist(add = true) {
        const {
            magentoProduct: { variants = [] },
            isLoading,
            showNotification,
            productsInWishlist,
            addProductToWishlist,
            removeProductFromWishlist,
            wishlistId,
            color
        } = this.props;

        const { isWishListToggle } = this.state;

        if (!isSignedIn()) {
            return showNotification(WISHLIST_ERROR, __('Please login or register to add items to your wishlist.'));
        }

        if (isLoading || isWishListToggle || !color) {
            return null;
        }

        const variant = variants.find(
            ({ color: vcolor }) => +vcolor === +color
        );

        if (!variant) {
            return null;
        }

        this.setWishlistButtonLoading(true);
        this.setState({ isWishListToggle: true });

        const { style_number } = variant;

        if (add) {
            await addProductToWishlist({
                items: [{ sku: style_number }],
                wishlistId
            });

            this.setState({ isWishListToggle: false });

            return;
        }

        const { wishlist: { id: item_id } } = Object.values(productsInWishlist).find(
            ({ wishlist: { sku } }) => sku === style_number
        );

        if (!item_id) {
            this.setState({ isWishListToggle: false });

            return;
        }

        this.setState({ isWishListToggle: false });

        return removeProductFromWishlist({ item_id });
    }

    render() {
        return (
            <ProductCardWishlistComponent
              { ...this.props }
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCardWishlistContainer);
